// removed by extract-text-webpack-plugin
module.exports = {"container":"_2pTCt4ZE7yVhJHPyFAWRst","marker":"_1PwyTDy0TKVXRuypaslgo0"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/Distance/style.scss
// module id = 974
// module chunks = 0